export default () => {
  const data = {
    event_name: 'tapped_select_field',
    button_name: 'rooms',
    page_section: 'filter_section',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
